import { useQueryClient } from "@tanstack/react-query";

import { useCurrentCompanyId } from "@/hooks";
import { CompanyUser } from "@/types";

/**
 * This hook is used to add a new company user to the company users
 * for settings query without refetching the entire query.
 */
export const useSetNewCompanyUserInCompanyUsersForSettings = () => {
  const currentCompanyId = useCurrentCompanyId();
  const queryClient = useQueryClient();

  return ({ companyUserToAdd }: { companyUserToAdd: CompanyUser }) => {
    queryClient.setQueryData(
      ["settings/company-users", currentCompanyId],
      (cachedData: CompanyUser[]) => {
        return [...cachedData, companyUserToAdd];
      },
    );
  };
};
